import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import AuctionDetailsAndTimeSlot from "./components/AuctionDetailsAndTimeSlot";
import LotsCollection from "./components/LotsCollection";
import CatalogueList from "./components/CatalogueList";
import { useDispatch } from "react-redux";
import { singleAuctionDetails } from "../../../../redux/action/singleAuction";
function AuctionDetails() {
  const { id } = useParams();
  const dispatch = useDispatch();
  const naviagte = useNavigate();

  useEffect(() => {
    dispatch(singleAuctionDetails(id));
  }, [id, dispatch]);

  return (
    <div>
      <span className="valign-wrapper gap-1">
        <span
          className={`material-icons pointer`}
          onClick={() => naviagte("/")}
        >
          west
        </span>
        <h4>Auction Detail</h4>
      </span>
      <div className={`flex gap-1 column`}>
        <AuctionDetailsAndTimeSlot />
        <LotsCollection />
        <CatalogueList />
      </div>
    </div>
  );
}

export default AuctionDetails;
